import { render, staticRenderFns } from "./LoginSideMenuContents.vue?vue&type=template&id=6b03a568"
import script from "./LoginSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginSideMenuContents.vue?vue&type=style&index=0&id=6b03a568&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports